import messages from "@/plugins/i18n";
import type { Ref } from "vue";
import { showConfirmationDialog } from "@/components/composables/promptDialogs";
import { onBeforeRouteLeave } from "@/components/platform/common/routerHooks";

export const bmLeaveConfirmationLeavePage = async (
  showDialog: boolean,
  next: Function
) => {
  if (
    !showDialog ||
    (await showConfirmationDialog(
      messages.prompt_leave_title,
      messages.prompt_leave_text
    ))
  ) {
    next();
  }
};

export const useLeaveDialog = (
  showDialog: Ref<boolean>,
  leaveTitle: string = messages.prompt_leave_title,
  leaveText: string = messages.prompt_leave_text
) => {
  const checkUserCanLeave = async () => {
    if (
      !showDialog.value ||
      (await showConfirmationDialog(leaveTitle, leaveText))
    ) {
      return true;
    }
    return false;
  };

  return {
    checkUserCanLeave,
  };
};

/**
 * Registers onBeforeRouteLeave to prompt when isDirty() is true.
 * Uses the Vue 2.7 setup-compatible router hook (render-fn pages included).
 * Must be called synchronously from setup so getCurrentInstance() resolves.
 */
export function useRouteLeaveDirtyCheck(isDirty: () => boolean) {
  onBeforeRouteLeave(async (_to, _from, next) => {
    await bmLeaveConfirmationLeavePage(isDirty(), next);
  });
}
